import { NavLink } from 'react-router-dom';
import { primaryNavigation, serviceNavigation } from '../../data/navigation';
import TopBar from './TopBar';
import MobileMenu from './MobileMenu';

const logoSrc = `${process.env.PUBLIC_URL}/images/logos/logo.svg`;

function Header() {
  return (
    <header className="site-header">
      <TopBar />
      <div className="container site-header__inner">
        <NavLink to="/" className="site-header__brand" aria-label="Evon Industrial Services home">
          <img className="site-header__logo" src={logoSrc} alt="" aria-hidden="true" />
          <span className="site-header__brand-text">
            <strong>Evon</strong>
            <small>Industrial Services</small>
          </span>
        </NavLink>

        <nav className="site-header__nav" aria-label="Primary navigation">
          {primaryNavigation.map((item) =>
            item.path === '/services' ? (
              <div key={item.path} className="site-header__nav-item site-header__nav-item--dropdown">
                <NavLink to={item.path}>{item.label}</NavLink>
                <div className="site-header__dropdown" aria-label="Services navigation">
                  {serviceNavigation.map((service) => (
                    <NavLink key={service.path} to={service.path}>
                      {service.label}
                    </NavLink>
                  ))}
                </div>
              </div>
            ) : (
              <NavLink key={item.path} to={item.path}>
                {item.label}
              </NavLink>
            )
          )}
        </nav>

        <NavLink to="/contact" className="site-header__quote">
          Request a Quote
        </NavLink>
        <MobileMenu />
      </div>
    </header>
  );
}

export default Header;
